import { useTranslation } from "react-i18next";
import AnimatedModal from "components/layout/motion/AnimatedModal";

/**
 * Shared safety modal when the robot is docked and the user attempts an action
 * that may stand, walk, load a map, or otherwise interrupt charging.
 */
const DockedActionGateModal = ({
    visible,
    body,
    onCancel,
    onProceed,
    onUndock,
    undockDisabled = false,
}) => {
    const { t } = useTranslation("control");

    return (
        <AnimatedModal
            visible={visible}
            onClose={onCancel}
            className="bg-black100 w-full max-w-md rounded-r10 border border-black80 px-5 py-4 text-white"
            zIndexClassName="z-[120]"
        >
            <p className="text-h4 font-semibold">{t("docking.chargingTitle")}</p>
            <p className="mt-2 text-h5 text-white/85">
                {body || t("docking.chargingBody")}
            </p>
            <div className="mt-4 flex flex-wrap justify-end gap-2">
                <button
                    type="button"
                    className="rounded-r5 border border-black60 bg-black60 px-3 py-1.5 text-h5 text-white hover:bg-black70"
                    onClick={onCancel}
                >
                    {t("feedback.cancel")}
                </button>
                <button
                    type="button"
                    className="rounded-r5 border border-black50 bg-black80 px-3 py-1.5 text-h5 text-white hover:bg-black70"
                    onClick={onProceed}
                >
                    {t("docking.chargingProceed")}
                </button>
                <button
                    type="button"
                    className="rounded-r5 border border-red-600 bg-red-600 px-3 py-1.5 text-h5 text-white hover:bg-red-500 disabled:opacity-60"
                    disabled={undockDisabled}
                    onClick={onUndock}
                >
                    {t("buttons.undock")}
                </button>
            </div>
        </AnimatedModal>
    );
};

export default DockedActionGateModal;
